<template lang="pug">
  title-tab(:msg="$t('title.setting')")
    template(slot='extensionBottom')
      v-tabs(
        v-model='currentItem'
        background-color='var(--bg-main-color)'
        slider-color='white'
      )
        v-tab(
          v-for='item in headers'
          :key='item'
          @click="GA('SelectTab',item)"
        )
          h4 {{ $t(item) }} 
    component(
      :is="curComponent"
    ) 

</template>
<script>  
import NTap01 from '@/views/Setting/childs/P01PersonalInformation.vue'
import NTap02 from '@/views/Setting/childs/P02Changepassword.vue'
import NTap03 from '@/views/Setting/childs/P03BankAccount.vue' 

export default {
  components:{ 
    NTap01,
    NTap02,
    NTap03, 
  },
  data : () => ({ 
    currentItem: 0,
    headers:['tab.personal-info','tab.change-password','tab.bank-account'],  
  }),
  computed : {
    curComponent () {
      switch(this.currentItem) {
        case 0:
          return 'n-tap-01'
        case 1:
          return 'n-tap-02'
        case 2:
          return 'n-tap-03'
        default:
          return 'n-tap-01'
      }
    }
  },
  mounted () {
    if (this.$route.query.tab === "bank") {
      this.currentItem = 2
    }
  },
  methods : {
    GA (actions,item){
      this.$ga.event('Button', actions, 'SettingPage',item)
    },  
  } 
}
</script> 